module.exports = __webpack_public_path__ + "static/media/Flaticon.08cb318f.woff";